export default __webpack_public_path__ + "static/media/proj2mov.1e22f70d.mp4";